enum VisibilityType {
    Public = 'Public',
    Private = 'Private',
}

export default VisibilityType;
